(() => {
  const instances = new WeakMap();
  const roots = (scope) => {
    const found = scope.matches?.('[data-dra-snapshot]') ? [scope] : [];
    return found.concat([...scope.querySelectorAll?.('[data-dra-snapshot]') || []]);
  };
  const init = (root) => {
    if (instances.has(root)) return;
    document.documentElement.classList.add('js');
    const items = [...root.querySelectorAll('[data-dra-motion]')];
    items.forEach((item) => { item.dataset.draReady = 'true'; });
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      instances.set(root, () => instances.delete(root));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }), { threshold: .12, rootMargin: '0px 0px -6%' });
    items.forEach((item) => observer.observe(item));
    instances.set(root, () => { observer.disconnect(); instances.delete(root); });
  };
  const initScope = (scope = document) => roots(scope).forEach(init);
  const unloadScope = (scope) => roots(scope).forEach((root) => instances.get(root)?.());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initScope(), { once: true }); else initScope();
  document.addEventListener('shopify:section:load', (event) => initScope(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadScope(event.target));
})();
